import {
  DashboardLessonProgressFilters,
  listDashboardLessonProgress,
} from '@/data/services/dashboardLessonProgress';
import {
  listStudentDashboardStats,
  StudentDashboardFilters,
} from '@/data/services/studentDashboardStatsServices';

const all = ['studentDashboard'] as const;

const courseProgressesKey = [...all, 'courseProgresses'] as const;

const lessonProgressesKey = [...all, 'lessonProgresses'] as const;

export const studentDashboardQueries = {
  all,

  courseProgresses: (filters: StudentDashboardFilters = {}) => ({
    queryKey: [...courseProgressesKey, { filters }] as const,
    queryFn: () => listStudentDashboardStats(filters),
  }),

  courseProgressesInfinite: (filters: StudentDashboardFilters = {}) => ({
    queryKey: [
      ...studentDashboardQueries.courseProgresses(filters).queryKey,
      'infinite',
    ] as const,
    queryFn: (ctx: { pageParam?: number }) =>
      listStudentDashboardStats({ ...filters, pageNumber: ctx.pageParam }),
  }),

  lessonProgresses: (filters: DashboardLessonProgressFilters = {}) => ({
    queryKey: [...lessonProgressesKey, { filters }] as const,
    queryFn: () => listDashboardLessonProgress(filters),
  }),

  lessonProgressesInfinite: (filters: DashboardLessonProgressFilters = {}) => ({
    queryKey: [
      ...studentDashboardQueries.lessonProgresses(filters).queryKey,
      'infinite',
    ] as const,
    queryFn: (ctx: { pageParam?: number }) =>
      listDashboardLessonProgress({ ...filters, pageNumber: ctx.pageParam }),
  }),
};
